import crmEnrichmentFiltersService from "../services/filters";

import type { CrmEnrichmentState, CrmEnrichmentWizardFilters } from "./types";

export const INITIAL_WIZARD_FILTERS: CrmEnrichmentWizardFilters = {
    isApplyFiltersSelected: true,
    filters: [crmEnrichmentFiltersService.getDefaultFilter()],
};

export const INITIAL_CRM_ENRICHMENT_STATE: CrmEnrichmentState = {
    jobName: "",
    isRenameModalOpen: false,
    isRemoveModalOpen: false,

    selectedJobType: "",
    selectedJobObject: "",
    selectedJobRefreshPeriod: "asSoonAsPossible",
    selectedCountryId: null,
    selectedEnrichmentSource: "company",
    selectedLeadScoreRefreshDataInterval: "weekly",

    wizardFilters: INITIAL_WIZARD_FILTERS,
    mappings: [],
};
